import { useConnectableClinics, useEffectiveTcGroups } from '@/hooks/use-tc-groups';
import { useMemo } from 'react';
// Encode a scope choice as a single Select value shared by the editor,
// promote, and gallery dialogs.
export const PERSONAL_SCOPE_VALUE = 'personal';
export const clinicScopeValue = (clinicId) => `clinic:${clinicId}`;
export const groupScopeValue = (groupId) => `group:${groupId}`;
export function parseScopeValue(value) {
    if (value.startsWith('clinic:')) {
        return { scope: 'enterprise', clinicId: value.slice('clinic:'.length) };
    }
    if (value.startsWith('group:')) {
        return { scope: 'group', groupId: value.slice('group:'.length) };
    }
    return { scope: 'personal' };
}
/**
 * The shared-scope targets the current user may write templates into,
 * mirroring the backend gates: enterprise = literal 'Clinic Admin' role in the
 * clinic (or super admin, folded in by useConnectableClinics), group = admin of
 * that consultant group (super admins are presented as admin of every group by
 * useEffectiveTcGroups).
 */
export function useTemplateScopeOptions() {
    const { clinics } = useConnectableClinics();
    const { groups } = useEffectiveTcGroups();
    return useMemo(() => ({
        clinics: clinics.map((c) => ({ clinicId: c.clinicId, clinicName: c.clinicName })),
        groups: groups.flatMap((g) => (g.role === 'admin' ? [{ id: g.id, name: g.name }] : [])),
    }), [clinics, groups]);
}
